import { render, staticRenderFns } from "./NewWorkerForm.vue?vue&type=template&id=6fc7acb6&scoped=true"
import script from "./NewWorkerForm.vue?vue&type=script&lang=js"
export * from "./NewWorkerForm.vue?vue&type=script&lang=js"
import style0 from "./NewWorkerForm.vue?vue&type=style&index=0&id=6fc7acb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc7acb6",
  null
  
)

export default component.exports